/* JELO · Compra directa con método de pago elegido en checkout, sin wallet destacado */
(() => {
  "use strict";
  document.addEventListener("click", async (event) => {
    const button = event.target.closest?.("[data-jelo-fast-checkout]");
    if (!button || button.disabled) return;
    event.preventDefault();
    const wrapper = button.closest("product-form-component");
    const form = wrapper?.querySelector('form[data-type="add-to-cart-form"]');
    const feedback = wrapper?.querySelector("[data-jelo-checkout-feedback]");
    if (!form) return;
    const data = new FormData(form);
    if (!data.get("id")) {
      if (feedback) { feedback.hidden = false; feedback.textContent = "Selecciona primero una variante."; }
      return;
    }
    const root = window.Shopify?.routes?.root || "/";
    button.disabled = true;
    button.textContent = "Preparando el pago…";
    if (feedback) { feedback.hidden = true; feedback.textContent = ""; }
    try {
      const response = await fetch(root + "cart/add.js", {method:"POST",body:data,credentials:"same-origin",headers:{"Accept":"application/json"}});
      if (!response.ok) {
        const body = await response.json().catch(() => ({}));
        throw new Error(body.description || "No se pudo añadir este producto. Revisa la variante y la cantidad.");
      }
      window.location.assign(root + "checkout");
    } catch (error) {
      button.disabled = false;
      button.textContent = "Comprar ahora · ir a pagar →";
      if (feedback) { feedback.hidden = false; feedback.textContent = error.message || "No se pudo iniciar el pago. Utiliza Agregar al carrito."; }
    }
  });
})();
